<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>币种划转设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-currency-introduction
          @refresh="refreshList"
        ></create-currency-introduction>
        <!-- <el-input
          placeholder="请输入划转状态（0或1）"
          clearable
          v-model="query"
          @keyup.enter.native="handleSearch()"
        >
      
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input> -->
        <el-select v-model="query" clearable placeholder="请选择">
          <el-option
            v-for="item in switchOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select v-model="tenantId" placeholder="租户选择" clearable>
          <el-option
            v-for="item in tenantList"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <currency-introduction-list
        @refresh="refreshList"
      ></currency-introduction-list>
    </el-card>
  </div>
</template>

<script>
import CurrencyIntroductionList from "./components/list";
import CreateCurrencyIntroduction from "./components/create";
import "./store";
import { mapActions, mapGetters, mapState } from "vuex";
import { PAGINATION } from "common/config";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "CurrencyTransfer",
  data() {
    return {
      query: "",
      tenantId: "",
      tenantList: [],
      switchOptions: [
        {
          value: 1,
          label: "开启",
        },
        {
          value: 0,
          label: "关闭",
        },
      ],
    };
  },
  components: {
    CurrencyIntroductionList,
    CreateCurrencyIntroduction,
  },
  computed: {
    ...mapState("currencyTransferSetting", ["pagination", "datas"]),
    ...mapGetters("currencyTransferSetting", ["optonsData"]),
  },
  methods: {
    ...mapActions("currencyTransferSetting", ["getList", "reqList"]),
    refreshList(data = {}) {
      this.getList({
        status: this.query,
        ...this.pagination,
        tenantId: this.tenantId,
        ...data,
      });
    },
    selectVal(e) {
      this.getList({
        status: e,
        tenantId: this.tenantId,
        ...this.pagination,
      });
    },
    handleSearch() {
      this.getList({
        status: this.query,
        ...this.pagination,
        tenantId: this.tenantId,
        page: 1,
      });
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.getList({
      ...PAGINATION,
      status: this.query,
      tenantId: this.tenantId,
    });

    // this.reqList({})
  },
};
</script>

<style lang="less" scoped></style>
